import { Local, LocalForm, LocalFormUpsert } from '@core/models';
import {
  convertHour,
  transformArrayScheduleForm,
  transformContactDetailForm,
  transformContactDetailUpsert,
  transformLocationForm,
  transformLocationUpsert,
} from '..';
import { toKebabCase } from '../general.helper';
import { StateEnum, StoreModeEnum } from '@core/enums';

export function transformToData(store: Local | null): Local | null {
  if (!store) return null;

  return {
    ...store,
    active: store?.estado?.descripcion === StateEnum.Active,
    horarios: (store.horarios || []).map((schedule) => {
      return {
        ...schedule,
        opening: convertHour(schedule.apertura),
        closing: convertHour(schedule.cierre),
      };
    }),
  };
}

export function transformArrayToData(stores: Local[]): Local[] {
  return ((stores ?? []).map((store) => (transformToData(store))).filter((l) => !!l)) ?? [];
}

export function transformToForm(store: Local): LocalForm {
  const {
    idLocal,
    nombre: name,
    version,
    slug,
    sitioWeb: website,
    socialFacebook: facebook,
    socialInstagram: instagram,
    entradaManual: manualEntry,
    facturacion: electronicBilling,
    tipoCierreDia: closingDayType,
    logo: logo,
    configuracionTienda,
    codigoInstalacion: installationCode,
    modo: mode,
    activo: active,
    horarios: schedules,
    ubicacion: location,
    datosContacto: contactData,
    // soporteId: supportId,
    resellerId,
    estado: status,
    cuenta: account,
  } = store;

  return {
    id: idLocal,
    name,
    version,
    slug,
    website,
    facebook,
    instagram,
    manualEntry,
    electronicBilling,
    closingDayType,
    logo,
    dateFormat: configuracionTienda?.configuracionTienda?.formatoFecha ?? undefined,
    currencySymbol: configuracionTienda?.configuracionTienda?.simboloMoneda ?? undefined,
    hourFormat: configuracionTienda?.configuracionTienda?.formatoHora ?? undefined,
    installationCode,
    mode: mode === StoreModeEnum.Demo,
    active,
    schedules: transformArrayScheduleForm(schedules),
    location: transformLocationForm(location),
    contactData: transformContactDetailForm(contactData),
    licenses: [],
    // supportId,
    resellerId,
    statusId: status?.idEstado,
    accountId: account?.idCuenta,
  };
}

export function transformArrayToForm(stores: Local[]): LocalForm[] {
  return (stores ?? []).map((store) => transformToForm(store)).filter((l) => !!l) ?? [];
}

export function transformToUpsert(localForm: LocalForm): LocalFormUpsert {
  const {
    name: nombre,
    website: sitioWeb,
    facebook: socialFacebook,
    instagram: socialInstagram,
    manualEntry: entradaManual,
    electronicBilling: facturacion,
    dateFormat: formatoFecha,
    currencySymbol: simboloMoneda,
    hourFormat: formatoHora,
    location,
    contactData,
    // supportId: soporteId,
    statusId: estadoId,
    accountId: cuentaId,
  } = localForm;

  return {
    nombre,
    slug: toKebabCase(nombre),
    sitioWeb: sitioWeb ?? '',
    socialFacebook: socialFacebook ?? '',
    socialInstagram: socialInstagram ?? '',
    entradaManual,
    facturacion,
    formatoFecha,
    simboloMoneda,
    formatoHora,
    ubicacion: transformLocationUpsert(location),
    datosContacto: transformContactDetailUpsert(contactData),
    // soporteId,
    estadoId,
    cuentaId,
  };
}

export function transformModeToUpsert({ mode }: LocalForm): string {

  return !!mode ? StoreModeEnum.Demo : StoreModeEnum.Production;
}
